export default __webpack_public_path__ + "static/media/icon-warnschwelle.1563e54c.svg";